import { useTranslation } from "react-i18next";
import { PeriodNavigator } from "components/designV2/periodNavigator/periodNavigator";
import { useTipsTransactions } from "./tips.transactions.hook";
import { TipsTransactionsLoader } from "./tips.transactionsLoader.component";
import {
  TransactionCard,
  TransactionHeader,
  TransactionLoadError,
  TransactionLoading,
  TransactionPeriodBar,
  TransactionTitle,
  TransactionTitleGroup,
} from "./tips.transactions.styled";
import { TipsTransactionsSummary } from "./tips.transactionsSummary.component";
import { TipsTransactionsTable } from "./tips.transactionsTable.component";
import type { TipsTransactionsProps } from "./tips.transactions.types";

export const TipsTransactions = (props: TipsTransactionsProps): JSX.Element => {
  const { companyId, currentDate, onCurrentDateChange } = props;
  const { i18n, t } = useTranslation();
  const viewModel = useTipsTransactions({
    companyId,
    currentDate,
    locale: i18n.language,
    onCurrentDateChange,
  });

  return (
    <>
      <TransactionPeriodBar>
        <PeriodNavigator
          currentDate={currentDate}
          mode="month"
          onChange={onCurrentDateChange}
          prevAriaLabel={t("Tips.PreviousMonth")}
          nextAriaLabel={t("Tips.NextMonth")}
        />
        <TipsTransactionsSummary
          activeSummaryFilter={viewModel.activeSummaryFilter}
          summary={viewModel.summary}
          onSummaryFilterChange={viewModel.onSummaryFilterChange}
        />
      </TransactionPeriodBar>

      <TransactionCard>
        <TransactionTitleGroup>
          <TransactionTitle>{viewModel.monthTitle}</TransactionTitle>
          <TransactionHeader>
            {t("Tips.TransactionsDescription")}
          </TransactionHeader>
        </TransactionTitleGroup>

        {viewModel.hasLoadError && viewModel.visibleTransactions.length > 0 && (
          <TransactionLoadError role="alert">
            {t("Alerts.SomethingWentWrong")}
          </TransactionLoadError>
        )}

        {viewModel.isLoading ? (
          <TransactionLoading>
            <TipsTransactionsLoader />
          </TransactionLoading>
        ) : viewModel.visibleTransactions.length === 0 ? (
          <TransactionLoading>
            {viewModel.hasMoreTransactions && viewModel.isLoadingMore ? (
              <TipsTransactionsLoader />
            ) : viewModel.hasLoadError ? (
              t("Alerts.SomethingWentWrong")
            ) : (
              t("TipCredit.NoDepositsOrWithdrawalsFound")
            )}
          </TransactionLoading>
        ) : (
          <TipsTransactionsTable
            hasMoreTransactions={viewModel.hasMoreTransactions}
            isLoadingMore={viewModel.isLoadingMore}
            loadMoreTriggerRef={viewModel.loadMoreTriggerRef}
            transactions={viewModel.visibleTransactions}
          />
        )}
      </TransactionCard>
    </>
  );
};
